import { Box, Typography, Button } from "@mui/material";
import React, { useState } from "react";

const Calculator = () => {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");

  const operators = ["+", "-", "*", "/"];

  const handleButtonClick = (value) => {
    // CLEAR
    if (value === "C") {
      setInput("");
      setResult("");
      return;
    }

    // BACKSPACE
    if (value === "⌫") {
      setInput((prev) => prev.slice(0, -1));
      return;
    }

    // EQUALS
    if (value === "=") {
      if (!input) return;

      try {
        // Prevent ending with operator
        if (operators.includes(input.slice(-1))) return;

        const calcResult = Function(`"use strict"; return (${input})`)();
        setResult(calcResult.toString());
      } catch {
        setResult("Error");
      }
      return;
    }

    // PREVENT MULTIPLE OPERATORS
    const lastChar = input.slice(-1);
    if (
      operators.includes(value) &&
      (operators.includes(lastChar) || input === "")
    ) {
      return;
    }

    setInput((prev) => prev + value);
  };

  const buttons = [
    "7",
    "8",
    "9",
    "/",
    "4",
    "5",
    "6",
    "*",
    "1",
    "2",
    "3",
    "-",
    "0",
    ".",
    "=",
    "+",
    "C",
    "⌫",
  ];

  return (
    <Box sx={{ width: "100%" }}>
      {" "}
      <Box
        sx={{
          p: 1,
          mb: 1,
          bgcolor: "#e1dfdfff",
          borderRadius: 1,
          textAlign: "right",
          minHeight: "20px",
        }}
      >
        {" "}
        <Typography
          variant="h6"
          sx={{
            maxWidth: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            marginLeft: "5px",
            /* scrollbar styling */
            "&::-webkit-scrollbar": {
              height: "4px", // 👈 scrollbar height
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#e0e0e0",
            },
          }}
        >
          {input || "0"}
        </Typography>{" "}
      </Box>{" "}
      <Box
        sx={{
          p: 1,
          mb: 1,
          bgcolor: "#e1dfdfff",
          borderRadius: 1,
          minHeight: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {" "}
        <Typography variant="body1"> Answer </Typography>{" "}
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{
            maxWidth: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            marginLeft: "5px",
            /* scrollbar styling */
            "&::-webkit-scrollbar": {
              height: "4px", // 👈 scrollbar height
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#e0e0e0",
            },
          }}
        >
          {" "}
          {Math.round(result * 100) / 100 || "0"}{" "}
        </Typography>{" "}
      </Box>{" "}
      <Box
        sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1 }}
      >
        {" "}
        {buttons.map((btn) => (
          <Button
            key={btn}
            variant="contained"
            onClick={() => handleButtonClick(btn)}
            sx={{
              minWidth: "40px",
              bgcolor: btn === "=" ? "#42A5F5" : "#e0e0e0",
              color: btn === "=" ? "white" : "black",
              "&:hover": { bgcolor: btn === "=" ? "#1976D2" : "#cfcfcf" },
            }}
          >
            {" "}
            {btn}{" "}
          </Button>
        ))}{" "}
      </Box>{" "}
    </Box>
  );
};

export default Calculator;
